export default {
    data: () => ({
      open: ["TGCA Documents Page"],
      files: {
        pdf: "picture_as_pdf",
      },
      tree: [],
    }),
    computed: {
      items() {
        return [
          {
            name: "TGCA Documents Page",
            children: [
              {
                name: "General",
                children: [
                  {
                    name: "Comunicados Oficiales 2019-2020",
                    children: [
                      {
                        name:
                          "🎓︎ Cierre de Año Escolar 2019-2020 - Asistencia, Evaluación, Promoción y Graduación de Estudiantes",
                        src:
                          "../../../../public/file/General/ComunicadosOficiales2019-2020/CIERRE DE AÑO ESCOLAR 2019-2020 - ASISTENCIA, EVALUACIÓN, PROMOCIÓN Y GRADUACIÓN DE ESTUDIANTES.pdf"
                      },
                      {
                        name:
                              "🎓︎ Evaluación del Aprendizaje de los Estudiantes en el Sistema de Información Estudiantil (SIE)",
  
                        src: "../../../../public/file/General/ComunicadosOficiales2019-2020/EVALUACIÓN DEL APRENDIZAJE DE LOS ESTUDIANTES EN EL SISTEMA DE INFORMACIÓN ESTUDIANTIL (SIE).pdf",
                      },
                    ],
                  },
                  {
                    name:
                      "🎓︎ Política Pública Sobre la Organización Escolar y los Requisitos de Promoción y Graduación",
                    src: "../../../../public/file/General/POLÍTICA PÚBLICA SOBRE LA ORGANIZACIÓN ESCOLAR Y LOS REQUISITOS DE PROMOCIÓN Y GRADUACIÓN.pdf",
                  },
                ],
              },
              {
                name: "Graduados",
                children: [
                ],
              },
              {
                name: "Otros",
                children: [
                  {
                    name: "Ordenes Ejecutivas COVID-19",
                    children: [
                      {
                        name: "🎓︎ OE-2020-021 - Para otorgar licencia especial a los servidores públicos que presenten síntomas sospechosos o diagnóstico de COVID-19.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-021.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-023 - Para viabilizar los cierres necesarios gubernamentales y privados para combatir los efectos del COVID-19 y controlar el riesgo de contagio en nuestra isla.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-023.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-029 - A los fines de extender las medidas tomadas para controlar el riesgo de contagio del COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-029.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-033 - A los fines de continuar las medidas tomadas para controlar el riesgo de contagio del COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-033.pdf",
                      },
                       {
                        name: "🎓︎ OE-2020-034 - A los fines de enmendar el toque de queda establecido en la OE-2020-033.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-034.pdf"
                      },
                       {
                        name: "🎓︎ OE-2020-038 - A los fines de extender el toque de queda y establecer otras medidas necesarias para controlar y prevenir el riesgo de contagio con COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-038.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-041 - A los fines de extender el toque de queda, con la reapertura gradual de sectores económicos y otros fines relacionados a las medidas tomadas para controlar el riesgo de contagio del COVID-19 en PR",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-041.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-044 - A los fines de establecer un nuevo toque de queda, continuar la reapertura económica y otros fines relacionados COVID-19.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-044.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-048 - A los fines de extender el toque de queda establecido, continuar la reapertura económica y otros fines relacionados al COVID-19.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-048.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-054 - A los fines de derogar el boletín administrativo núm. OE-2020-048 a los fines de adoptar medidas más restrictivas para controlar la propagación del COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-054.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-057 - A los fines de enmendar el boletín administrativo núm. OE-2020-054 a los fines de adoptar medidas más restrictivas para controlar la propagación del COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-057.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-060 - A los fines de extender el toque de queda establecido y continuar con las medidas restrictivas para controlar la propagación del COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-060.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-061 - A los fines de enmendar el boletín administrativo núm. OE-2020-060 para extender el toque de queda establecido y continuar con las medidas restrictivas para controlar la propagación del COVID-19 en PR.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-061.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-062 - A los fines de extender el toque de queda establecido y restringir las medidas tomadas para controlar la propagación del COVID-19 en Puerto Rico.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-062.pdf"
                      },
                      {
                        name: "🎓︎ OE-2020-064 - A los fines de realizar enmienda técnica al boletín administrativo número OE-2020-062.",
                        src: "../../../../public/file/Otros/Ordenes Ejecutivas COVID-19/OE-2020-064.pdf"
                      },
                    ]
                  },
                    {
                      name: "🎓︎ Memorando Especial Núm.13 - 2020",
                      src: "../../../../public/file/Otros/Memorando Especial Núm.13 - 2020.pdf"
                    },
                ],
              },
              {
                name: "Pre Monitoría y Monitoría",
                children: [
                  {
                    name: "🎓︎ Notificación sobre Visitas de Monitoria Federal (TGCA) 2019-20 (Firmado)",
                    file: "../../../../public/file/PreMonitoria/Notificación sobre Visitas de Monitoria Federal (TGCA) 2019-20 (Firmado).pdf",
                  },
                ],
              },
            ],
          },
        ];
      },
    },
  
    methods: {
      onUpdate(tree) {
        // console.log(tree[0].src);
        window.open("../../../../public/file/" + tree[0].src, "_blank");
      },
    },
  };


// WEBPACK FOOTER //
// ./src/components/documentos/index/script.js